import { useMemo } from 'react'

import { useQuery } from 'react-query'

import { SecondaryCategory } from '@webapp/core/entities/internal/SecondaryCategory'
import { REPORT_ENTITY_STALE_TIME_MS } from '@webapp/modules/reports/constants'
import { isNotFoundError } from '@webapp/modules/reports/utils/isNotFoundError'
import { secondaryCategoryQueryConfig } from '@webapp/platform/organization-management/query-configs/secondaryCategory'

// Reuses the existing core SecondaryCategoryRepository.getById via the
// owning domain's query config (ADR-6; deprecated core entity location
// kept per ADR-8 deferred cleanup). `enabled` lets the config-driven
// detail FS call all three header hooks unconditionally (rules-of-hooks).
export const useQueryReportSecondaryCategory = (
  secondaryCategoryId: number,
  enabled = true,
  { onError }: { onError?: (error: unknown) => void } = {}
) => {
  const { data, isFetching, error } = useQuery({
    ...secondaryCategoryQueryConfig.getById(secondaryCategoryId),
    staleTime: REPORT_ENTITY_STALE_TIME_MS,
    enabled,
    // A 404 is reported through `isNotFound`; only other failures reach
    // the caller's handler.
    onError:
      onError &&
      ((queryError: unknown) => {
        if (!isNotFoundError(queryError)) {
          onError(queryError)
        }
      }),
  })

  const secondaryCategory = useMemo(
    () => (data?.data ? new SecondaryCategory(data.data) : null),
    [data]
  )

  return {
    secondaryCategory,
    isLoading: isFetching,
    isNotFound: isNotFoundError(error),
  }
}
